import { PositiveFill } from 'ui/icons/status/PositiveFill';
import { NegativeFill } from 'ui/icons/status/NegativeFill';
import { colors } from 'ui/theme/colors';

type Props = {
  checked: boolean;
};

export default ({ checked }: Props) => {
  return checked ? (
    <PositiveFill color={colors.positive100} />
  ) : (
    <NegativeFill color={colors.grey15} />
  );
};
